import axios from "axios";
import { useEffect, useState } from "react";
import "./lobbybrowser.css";

interface GameListing {
    GameId: number;
    HostName: string;
    PlayerCount: number;
    MaxPlayers: number;
}

interface Lobby {
    code: string;
    mode: string;
    playerCount: number;
    maxPlayers: number;
}

function Int2Code(input: number): string {
    const V2 = "QWXRTYLPESDFGHUJKZOCVBINMA";
    var a = input & 0x3ff;
    var b = (input >> 10) & 0xfffff;

    return `${V2[a % 26]}${V2[Math.floor(a / 26)]}${V2[b % 26]}${
        V2[Math.floor((b / 26) % 26)]
    }${V2[Math.floor((b / (26 * 26)) % 26)]}${
        V2[Math.floor((b / (26 * 26 * 26)) % 26)]
    }`;
}

export default function LobbyBrowser() {
    const [lobbies, setLobbies] = useState<Lobby[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [copiedCode, setCopiedCode] = useState<string | null>(null);

    useEffect(() => {
        axios
            .get("https://play.skeld.net/api/games/filtered")
            .then((response: any) => {
                const games = response.data.games as GameListing[];
                setLobbies(
                    games.map((g) => ({
                        code: Int2Code(g.GameId),
                        mode: g.HostName,
                        playerCount: g.PlayerCount,
                        maxPlayers: g.MaxPlayers,
                    }))
                );
                setLoaded(true);
            })
            .catch(() => {
                setHasError(true);
                setLoaded(true);
            });
    }, []);

    const copyCode = (code: string) => {
        navigator.clipboard.writeText(code);
        setCopiedCode(code);
        setTimeout(() => setCopiedCode(null), 1500);
    };

    return (
        <div>
            <h2 className="section-heading">Lobby Browser</h2>
            <div className="panel">
                {!loaded ? (
                    <p className="mb-0">Loading the lobby browser...</p>
                ) : hasError ? (
                    <p className="mb-0">
                        Couldn't load the lobby browser right now — try again
                        in a bit.
                    </p>
                ) : lobbies.length === 0 ? (
                    <p className="mb-0">
                        No active lobbies right now — check back soon!
                    </p>
                ) : (
                    <>
                        <p>
                            Tap a code to copy it, then paste it into Among Us
                            to join.
                        </p>
                        <div className="lobby-grid">
                            {lobbies.map((lobby) => (
                                <div className="lobby-card" key={lobby.code}>
                                    <div className="lobby-card-header">
                                        <span className="lobby-mode">
                                            {lobby.mode}
                                        </span>
                                        <span className="lobby-players">
                                            {lobby.playerCount}/
                                            {lobby.maxPlayers}
                                        </span>
                                    </div>
                                    <button
                                        type="button"
                                        className="code-chip"
                                        onClick={() => copyCode(lobby.code)}
                                    >
                                        {copiedCode === lobby.code
                                            ? "Copied!"
                                            : lobby.code}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
